<template>
  <div class="lawyer-details-list-item border" @click="toLegalServices">
    <img class="image m-r-30" :src="image" />
    <div class="body f-1 f-column">
      <div class="font-lg m-b-15">{{title}}</div>
      <div class="darkgray-font font-sm m-b-10">法律关系(案由)：{{lawTypeDictEs}}</div>
      <div class="darkgray-font font-sm m-b-10">定制时间：{{time}}</div>
      <div class="flex f-y-center m-b-10">
        <div class="darkgray-font font-sm m-r-15">已服务客户</div>
        <div class="primary-font font">{{clientNumber}}</div>
      </div>
      <div class="orange-font font-lg m-b-15">{{price}}</div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, onBeforeMount } from 'vue'
import router from '@/router'
import { getUrlQuery, isUrl } from '@/utils/url.js'
import { fileApi } from '@/apis'
// /news/details/:id
export default {
  props: {
    id: Number,
    image: String,
    title: String,
    lawTypeDictEs: String,
    time: String,
    clientNumber: Number,
    price: String,
  },
  setup(props, { emit }) {
    console.log('props', props)
    const toLegalServices = () => {
      router.push('/lawyer/legalServices/' + props.id)
    }
    return { toLegalServices }
  },
}
</script>

<style lang="scss">
.lawyer-details-list-item {
  display: flex;
  padding: 20px 25px 25px 35px;
  .image {
    width: 158px;
    height: 158px;
    background-color: yellow;
  }
}
</style>